import { apiInstance } from "./networking";

export const getPanCardDetails = async (payload, { txnid }) => {
  const { data = {} } = await apiInstance.post(
    // SINZY open API
    // `primary/v2/ckyc-details?txnid=${txnid}`,
    // SINZY encrypted API
    // `primary/ckyc-details?txnid=${txnid}`,
    // ARYA API
    `primary/arya-ind-details?txnid=${txnid}`,
    payload
  );
  return data;
};




// export const getPanCardDetailsV2 = async (payload, txnid ) => {
//   console.log({payload})
//   const { data = {} } = await apiInstance.post(
//     `/V2/primary/arya-ind-details?${txnid}`,
//     payload
//   );
//   return data;
// };



// NEW CERSAI API FOR pancardFrame1.js  on cersai-kyc route
export const getPanCardDetailsCersai = async (payload, txnid , signal ) => {
  console.log({payload})
  const { data = {} } = await apiInstance.post(
    `/V2/primary/ind-ckyc-details?${txnid}`,
    payload,
    {signal}
  );
  return data;
};

// OTP FLOW API for pancard
export const getPanCardDetailsV2 = async (payload, txnid, signal) => {
  console.log({payload})
  const { data = {} } = await apiInstance.post(
    `/V2/primary/ind-ckyc-details?${txnid}`,
    payload, 
    {signal} // ABORT REQUEST
  );
  return data;
};
export const getPanCardDetailsV3 = async (payload, txnid, signal) => {
  console.log({payload})
  const { data = {} } = await apiInstance.post(
    `/V2/primary/ind-ckyc-details-2?${txnid}`,
    payload, 
    {signal} // ABORT REQUEST
  );
  return data;
};
